// Netlify Forms submission helper.
//
// On a Netlify-hosted site, the platform intercepts POSTs to ANY path on
// the same origin (we POST to "/") provided:
//   - Content-Type: application/x-www-form-urlencoded
//   - body contains `form-name=<name>` matching a form that Netlify
//     detected at build time (we keep static <form> clones in
//     public/index.html for that detection).
//
// This helper returns:
//   - true   when the POST resolves with a 2xx/3xx (Netlify accepted it,
//            OR we're on a non-Netlify host where POST to / returns the SPA)
//   - false  on any network/HTTP failure
//
// We never throw — callers should treat this as the source of truth for
// "did the form submission succeed?" on production.

const encode = (data) =>
  Object.keys(data)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k] ?? ""))
    .join("&");

export async function submitToNetlify(formName, payload) {
  try {
    const res = await fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": formName, ...payload }),
    });
    // 200 / 303 (Netlify's success redirect) both count as success.
    return res.ok || res.status === 303;
  } catch {
    return false;
  }
}
